import {
  doGetQCXRequest,
  doPostQCXRequest,
  doPutQCXActivateRequest,
  doPutQCXInactivateRequest,
  doPutQCXRequest,
} from '../../utils/api/domain/domain-api-utils';
import { COTACAO_ENDPOINT } from '../../utils/api/domain/domain-endpoint-utils';

export async function fetchAll() {
  return doGetQCXRequest([
    COTACAO_ENDPOINT
  ]);
}

export async function fetchById(id) {
  return doGetQCXRequest([
    COTACAO_ENDPOINT,
    id
  ]);
}

export async function register(data) {
  return doPostQCXRequest(
    [COTACAO_ENDPOINT],
    data
  );
}

export async function save(data) {
  return doPutQCXRequest(
    [COTACAO_ENDPOINT],
    data
  );
}

export async function activateById(id) {
  return doPutQCXActivateRequest(
    [COTACAO_ENDPOINT],
    id
  );
}

export async function inactivateById(id) {
  return doPutQCXInactivateRequest(
    [COTACAO_ENDPOINT],
    id
  );
}
